import {styled} from "@mui/material/styles"

interface TileImageComponentProps {
    imageRatio?: string
}
export const TileImageComponent = styled("img")<TileImageComponentProps>`
    width: 100%;
    height: auto;
    display: block;
    ${({imageRatio}) => imageRatio && `aspect-ratio: ${imageRatio.replace("x", "/")};`};
`
